import { RepeatLayoutMetadata } from "../../common-shared-module/model/dyn-form/form-metadata/layout/repeat-layout-metadata.model"
import { MetadataFactory } from "../../common-shared-module/model/dyn-form/form-metadata/metadata.factory"
import { Identified } from "./identified.model"
import { Layout } from "./layout.model"
import { RowLayout } from "./row-layout.model"


export class RepeatLayout implements Layout, Identified {

    rows: RowLayout[] = []
    metadata: RepeatLayoutMetadata
    icon: string = 'repeat_one'

    
    constructor(meta?: RepeatLayoutMetadata) {
        this.metadata = meta ? meta : MetadataFactory.createRepeatLayout()
    }

    id(): string {
        return this.metadata.id
    }

    label(): string {
        return this.metadata.name
    }

    removeRow(row: RowLayout) {
        this.rows = this.rows.filter(r => r != row)
    }

    getRows(): RowLayout [] {
        return this.rows
    }

    layout(): RepeatLayoutMetadata {
        return this.metadata
    }

}